import { Modal } from './models/qa.model';
import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { ComponentMap } from './models/component.map';
import { StartupService } from './services/startup.service';
import { Subscription } from 'rxjs/Subscription';

import { Location } from '@angular/common';
import { HistoryService } from './services/history.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private errorSubscription: Subscription;
  public model: object = this;
  public hideNetworkErrorModal: boolean = true;
  public modal: Modal;

  @HostListener('window:popstate', ['$event']) onPopState(e) {
    // window.location.replace(window.location.origin);
    this.historyService.back();
  }

  constructor(
    private startupService: StartupService,
    private router: Router,
    private locationService: Location,
    private historyService: HistoryService
  ) {

  }

  ngOnInit() {
    // this.errorSubscription = this.startupService.errorModalState.subscribe(x => {
      // this.hideNetworkErrorModal = !x;
      // this.modal = new Modal ({
      //  Title: 'Oops',
      //  Text: 'It seems we have a network problem.',
      //  HideModal: this.hideNetworkErrorModal,
      //  ButtonText: 'Home',
      //  ButtonClickFunction: () => {window.location.href='/';}
      // });
    // });
    if (window.location.pathname.toLocaleLowerCase() !== '/en-us/welcome') {
      // this.router.navigateByUrl('/en-us/welcome');
      window.location.pathname = '/en-us/welcome';
    } else {

      this.router.resetConfig(this.startupService.startupData.Routes.map(route => {
        if (route.component != null) {
          route.component = ComponentMap.GetComponentByName(route.component);
        }
        return route;
      }));

      const head = document.getElementsByTagName('head')[0];

      head.appendChild(this.createMetaTag('gtmLanguage', this.startupService.startupData.BrandInfo.GtmLanguage));
      head.appendChild(this.createMetaTag('gtmBrandName', this.startupService.startupData.BrandInfo.GtmBrandName));
      head.appendChild(this.createMetaTag('gtmProperty', this.startupService.startupData.BrandInfo.GtmProperty));

      const imagePath = this.startupService.startupData.BrandInfo.BackgroundImage;
      // Preload background
      let img = new Image();
      img.src = imagePath;

      img.onload = () => {
        document.querySelector('body').style.backgroundImage = `url('${imagePath}')`;
        document.querySelector('body').style.opacity = `1`;
        document.getElementById('app-overlay').classList.remove('animate');
        // Remove overlay div when animation is complete
        setTimeout(() => document.getElementById('app-overlay').outerHTML = '', 200);
        img = null;
      };
    }

  }

  createMetaTag(name: string, content: string) {
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;

    return meta;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts